export default {
  state: () => ({
    isTablet: false,
    showCart: false,
    showAccountDropdown: false,
    showLanguageDropdown: false,
    showMenuDropdown: false,
    showSearchDropdown: false,
  }),
  mutations: {
    setIsTablet(state, payload) {
      state.isTablet = payload
    },
    setShowCart(state, payload) {
      state.showCart = payload
    },
    setShowAccountDropdown(state, payload) {
      state.showAccountDropdown = payload
    },
    setShowLanguageDropdown(state, payload) {
      state.showLanguageDropdown = payload
    },
    setShowMenuDropdown(state, payload) {
      state.showMenuDropdown = payload
    },
    setShowSearchDropdown(state, payload) {
      state.showSearchDropdown = payload
    },
    clearOtherDropdowns(state, payload) {
      state.showCart = false
      state.showAccountDropdown = false
      state.showLanguageDropdown = false
      state.showMenuDropdown = false
      state.showSearchDropdown = false

      state[payload] = true
    },
    clearAllDropdowns(state) {
      state.showCart = false
      state.showAccountDropdown = false
      state.showLanguageDropdown = false
      state.showMenuDropdown = false
      state.showSearchDropdown = false
    }
  },
  getters: {
    isTablet(state) {
      return state.isTablet
    },
    showCart(state) {
      return state.showCart
    },
    showAccountDropdown(state) {
      return state.showAccountDropdown
    },
    showLanguageDropdown(state) {
      return state.showLanguageDropdown
    },
    showMenuDropdown(state) {
      return state.showMenuDropdown
    },
    showSearchDropdown(state) {
      return state.showSearchDropdown
    }
  },
}
